import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { get as getCameraList } from 'api/SdRecordViewer/sdRecordViewerCameraList';
import { CameraObject } from 'api/SdRecordViewer/sdRecordViewerCameraList';
import { useRedirectToCamera } from '../hooks/useRedirectToCamera';
import Breadcrumbs from '../Header/Breadcrumbs';
import { useTranslation } from 'react-i18next';
import StyledTable from 'components/StyledTable';

//画像取得時の開始・終了時刻の設定

/* カメラ一覧を取得して、各カメラの最新画像表示用コンポーネントを作成する */
const CameraList: React.FC = () => {
  const { t } = useTranslation('sdRecordViewer');
  const paths: { name: string; path: string }[] = [];
  const [cameras, setCameras] = useState<CameraObject[]>([]);
  const { onClickRedirect } = useRedirectToCamera();

  useEffect(() => {
    // 初回レンダリングでカメラ情報の一覧を取得
    getCameraList(res => {
      setCameras(res.cameras);
    });
  }, []);

  return (
    <Container>
      <div>
        <Breadcrumbs paths={paths} />
      </div>
      <StyledTable tableLayoutFixed noMargin>
        <>
          <thead>
            <tr>
              <th>{t('location')}</th>
              <th>{t('cameraName')}</th>
            </tr>
          </thead>
        </>
      </StyledTable>
      <ScrollBodyDiv>
        <StyledTable tableLayoutFixed withHighlight noMargin>
          <>
            <tbody>
              {cameras.map(cam => (
                <tr key={cam.camera_id}>
                  <td>{cam.location_name}</td>
                  <td>
                    <Link
                      to="/sd_record_viewer/camera_list"
                      onClick={() => cam && onClickRedirect(cam.redirect_url)}
                    >
                      {cam.camera_display_name}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </>
        </StyledTable>
      </ScrollBodyDiv>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  padding: 5px;
`;
const ScrollBodyDiv = styled.div`
  max-height: calc(100vh - 240px);
  overflow-y: scroll;
`;

export default CameraList;
